import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { OtherTranslationId } from '../../../types';

export const useOtherTranslation = () => {
  const intl = useIntl();
  return useMemo(() => intl.formatMessage({ id: OtherTranslationId }), [intl]);
};
